interface BeforeInstallPromptEvent extends Event {
	prompt: () => Promise<void>;
	userChoice: Promise<{ outcome: "accepted" | "dismissed"; platform: string }>;
}

interface InstallPromptSnapshot {
	deferredPrompt: BeforeInstallPromptEvent | null;
	installed: boolean;
}

let snapshot: InstallPromptSnapshot = { deferredPrompt: null, installed: false };
const listeners = new Set<() => void>();

const emit = (next: InstallPromptSnapshot): void => {
	snapshot = next;
	for (const listener of listeners) listener();
};

if (typeof window !== "undefined") {
	window.addEventListener("beforeinstallprompt", (event: Event) => {
		event.preventDefault();
		emit({ deferredPrompt: event as BeforeInstallPromptEvent, installed: false });
	});
	window.addEventListener("appinstalled", () => {
		emit({ deferredPrompt: null, installed: true });
	});
}

export const subscribeInstallPrompt = (listener: () => void): (() => void) => {
	listeners.add(listener);
	return () => {
		listeners.delete(listener);
	};
};

export const getInstallPromptSnapshot = (): InstallPromptSnapshot => snapshot;

export const clearDeferredPrompt = (): void => {
	if (snapshot.deferredPrompt === null) return;
	emit({ deferredPrompt: null, installed: snapshot.installed });
};

export type { BeforeInstallPromptEvent, InstallPromptSnapshot };
export default getInstallPromptSnapshot;
